var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import AutocompleteCore from './Autocomplete';
import { useThemeProps } from '@mui/material';
import Input from '../Input';
var Autocomplete = function (inProps) {
    var props = useThemeProps({ props: inProps, name: 'MuiAutocomplete' });
    return (React.createElement(AutocompleteCore, __assign({ renderInput: function (props) { return (React.createElement(Input, __assign({}, props, (inProps.placeholderIsValue && {
            label: inProps.label,
            notched: true,
        })))); } }, props)));
};
export default Autocomplete;
